"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarCard_component_exports = {};
__export(AvatarCard_component_exports, {
  AvatarCard: () => AvatarCard,
  default: () => AvatarCard_component_default
});
module.exports = __toCommonJS(AvatarCard_component_exports);
var import_react = __toESM(require("react"));
var import_truncate = __toESM(require("lodash/truncate"));
var import_atoms = require("../../atoms");
var import_Badge = require("../../atoms/Badge/Badge.component");
var import_constants = require("../../../constants");
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_react_i18next = require("react-i18next");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_RoleSwitchModal = require("../../organisms/RoleSwitchModal/RoleSwitchModal.component");
var import_roles = require("../../../utils/roles");
var import_AvatarCard = require("./AvatarCard.styled");
var _excluded = ["user", "onLogout", "onChangeRole", "currentRole", "availableRoles", "appElement", "mobileView", "withKebabMenu", "showLogoutButton", "impersonating", "endImpersonationButtonText", "CustomLogoutActionElement", "hideAppSelector"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var LogoutElement = function LogoutElement2(_ref) {
  var onClick = _ref.onClick, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "primary" : _ref$variant, customLabel = _ref.customLabel, customStyles = _ref.customStyles, customIcon = _ref.customIcon, toolTipText = _ref.toolTipText, logoutText = _ref.logoutText;
  return /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLogoutToolTip, {
    placement: "bottom",
    value: toolTipText,
    customizedHeight: "auto",
    customizedWidth: "270px",
    ariaLabel: toolTipText,
    textAlign: "center",
    aria: {
      content: "describedby",
      expanded: false
    }
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLogout, {
    icon: customIcon,
    iconSize: 17,
    onClick,
    variant: variant === "primary" ? "primary" : "ghost",
    className: "logout-button",
    "data-testid": "logout-button",
    "data-dp-analytics-id": "GlobalElementsAvatarPopupLogOutButton",
    customStyles
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledText, null, customLabel || logoutText)));
};
var AvatarCard = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref2, componentRef) {
  var _props$closeAvatarBut;
  var user = _ref2.user, onLogout = _ref2.onLogout, _ref2$onChangeRole = _ref2.onChangeRole, onChangeRole = _ref2$onChangeRole === void 0 ? void 0 : _ref2$onChangeRole, _ref2$currentRole = _ref2.currentRole, currentRole = _ref2$currentRole === void 0 ? import_roles.NOT_ROLE_SELECTED : _ref2$currentRole, _ref2$availableRoles = _ref2.availableRoles, availableRoles = _ref2$availableRoles === void 0 ? [] : _ref2$availableRoles, _ref2$appElement = _ref2.appElement, appElement = _ref2$appElement === void 0 ? "head" : _ref2$appElement, _ref2$mobileView = _ref2.mobileView, mobileView = _ref2$mobileView === void 0 ? false : _ref2$mobileView, _ref2$withKebabMenu = _ref2.withKebabMenu, withKebabMenu = _ref2$withKebabMenu === void 0 ? true : _ref2$withKebabMenu, _ref2$showLogoutButto = _ref2.showLogoutButton, showLogoutButton = _ref2$showLogoutButto === void 0 ? {
    show: true,
    customIcon: "go-to"
  } : _ref2$showLogoutButto, _ref2$impersonating = _ref2.impersonating, impersonating = _ref2$impersonating === void 0 ? false : _ref2$impersonating, _ref2$endImpersonatio = _ref2.endImpersonationButtonText, endImpersonationButtonText = _ref2$endImpersonatio === void 0 ? "End Impersonation" : _ref2$endImpersonatio, _ref2$CustomLogoutAct = _ref2.CustomLogoutActionElement, CustomLogoutActionElement = _ref2$CustomLogoutAct === void 0 ? false : _ref2$CustomLogoutAct, _ref2$hideAppSelector = _ref2.hideAppSelector, hideAppSelector = _ref2$hideAppSelector === void 0 ? false : _ref2$hideAppSelector, props = _objectWithoutProperties(_ref2, _excluded);
  var rawName = "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName);
  var username = (0, import_truncate.default)(rawName, {
    length: 40,
    separator: " "
  });
  var currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  var _getRoleInfo = (0, import_roles.getRoleInfo)(currentRole), roleName = _getRoleInfo.name, roleIcon = _getRoleInfo.icon;
  var hasRoleSelected = currentRole && currentRole !== import_roles.NOT_ROLE_SELECTED;
  var displayRoleSection = hasRoleSelected && ![import_roles.GM_DIS_ROLE, import_roles.GM_DCST_ROLE, import_roles.GM_PS_ROLE].includes(currentRole);
  var roleTypesValues = Object.keys(import_roles.rolesData);
  var shouldBeAbleToSwitchRole = hasRoleSelected && availableRoles.every(function(role) {
    return roleTypesValues.includes(role);
  }) && availableRoles.includes(currentRole) && availableRoles.length > 1;
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var showAppSelector = !hideAppSelector && withKebabMenu && breakpoints.isSm;
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var LogOutButton = /* @__PURE__ */ import_react.default.createElement(LogoutElement, {
    onClick: onLogout,
    variant: showLogoutButton.variant,
    customLabel: showLogoutButton.customLabel,
    customStyles: showLogoutButton.customStyles,
    customIcon: showLogoutButton.customIcon,
    toolTipText: t("dp_core_avatarCard_logOutTooltip"),
    logoutText: t("base_action_logOut")
  });
  return /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledAvatarPopupWindowScroll, {
    heightPopup: props.scrollHeightPopup,
    is400percent: breakpoints.isSm,
    isKebabMenu: withKebabMenu,
    isStudentVariant: props.studentVariant,
    "data-testid": "window-avatar-container"
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledCard, {
    ref: componentRef,
    className: "user-avatar-container"
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledCloseButtonContainer, null, /* @__PURE__ */ import_react.default.createElement(import_atoms.Button, {
    icon: "x",
    "aria-label": (_props$closeAvatarBut = props.closeAvatarButtonProps) !== null && _props$closeAvatarBut !== void 0 && _props$closeAvatarBut.ariaLabel ? props.closeAvatarButtonProps.ariaLabel : t("dp_core_avatarCard_closeButton"),
    iconSize: 20,
    onClick: props.closeAvatar,
    variant: "empty",
    circle: true,
    size: "40px",
    "data-testid": "closeAvatarButtonModal"
  })), /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledAppSelectorContainer, {
    showAppSelector
  }, props.appSelector), /* @__PURE__ */ import_react.default.createElement(import_atoms.Avatar, {
    fontSize: impersonating ? "medium" : "extraLarge",
    size: 54,
    user,
    impersonating
  }), impersonating && /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledImpersonationTitle, null, "Impersonating"), rawName.length > 40 ? /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
    value: rawName,
    placement: "bottom"
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledHeading, {
    showLogoutButton: showLogoutButton.show,
    weight: "black",
    size: "extraLarge",
    level: 1,
    "aria-hidden": "false"
  }, username)) : /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledHeading, {
    showLogoutButton: showLogoutButton.show,
    weight: "black",
    size: "extraLarge",
    level: 1,
    "aria-hidden": "false"
  }, username), displayRoleSection && /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledRoleContainer, null, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledRoleBadge, {
    icon: roleIcon,
    iconSize: 24,
    text: t(roleName),
    badgeType: import_Badge.BadgeType.round,
    badgeColor: import_Badge.BadgeColor.transparent
  }), shouldBeAbleToSwitchRole && /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_RoleSwitchModal.RoleSwitchModal, {
    user,
    currentRole,
    availableRoles,
    onChangeRole,
    appElement,
    mobileView,
    withKebabMenu
  }))), showLogoutButton.show && !impersonating ? CustomLogoutActionElement || LogOutButton : null, impersonating && /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledEndImpersonationButton, {
    iconSize: 17,
    icon: "square",
    style: {
      fontSize: "14px"
    },
    variant: "primary",
    onClick: props.onEndImpersonation && props.onEndImpersonation,
    "data-testid": "end-impersonation-button",
    hasRoleSwitcher: displayRoleSection
  }, endImpersonationButtonText), impersonating && /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledImpersonationArea, {
    showLogoutButton
  }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLoggedInAsUserLabel, null, "Logged in as"), /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLoggedInAsUser, null, props.impersonator && props.impersonator), showLogoutButton.show ? CustomLogoutActionElement || LogOutButton : null), /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLinksCopyright, null, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLinksContainer, null, import_constants.links.map(function(link) {
    return /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLinkItem, {
      key: t(link.text)
    }, /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledLinks, {
      "data-dp-analytics-id": link.dataDpAnalyticsId,
      href: link.href,
      target: "_blank",
      key: t(link.text),
      "data-testid": link.dataDpAnalyticsId
    }, t(link.text), /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
      icon: "redirect-link",
      size: 10
    })));
  })), /* @__PURE__ */ import_react.default.createElement(import_AvatarCard.StyledParagraph, {
    size: "extraSmall"
  }, "\xA9 ".concat(currentYear, " GREAT MINDS PBC")))));
});
var AvatarCard_component_default = AvatarCard;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AvatarCard
});
//# sourceMappingURL=AvatarCard.component.js.map